import { render, staticRenderFns } from "./SimInfo.vue?vue&type=template&id=5e489231&scoped=true"
import script from "./SimInfo.vue?vue&type=script&lang=js"
export * from "./SimInfo.vue?vue&type=script&lang=js"
import style0 from "./SimInfo.vue?vue&type=style&index=0&id=5e489231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e489231",
  null
  
)

export default component.exports